import React from "react";

import { ServerStatusFilterValue } from "./ServerListFilters";

interface ServerStatusPillsProps {
  value: ServerStatusFilterValue;
  onChange: (value: ServerStatusFilterValue) => void;
}

const ServerStatusPills: React.FC<ServerStatusPillsProps> = ({
  value,
  onChange,
}) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        color: "#64748b",
        letterSpacing: "0.05em",
      }}
    >
      Status
    </span>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: 4,
        background: "#e2e8f0",
        borderRadius: 9999,
      }}
    >
      {([
        { value: "", label: "All" },
        { value: "true", label: "Active" },
        { value: "false", label: "Inactive" },
      ] as const).map((option) => {
        const selected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 500,
              borderRadius: 9999,
              border: "none",
              cursor: "pointer",
              background: selected
                ? option.value === "true"
                  ? "#10b981"
                  : option.value === "false"
                    ? "#94a3b8"
                    : "#ffffff"
                : "transparent",
              color: selected
                ? option.value === ""
                  ? "#334155"
                  : "#ffffff"
                : "#64748b",
              boxShadow: selected
                ? "0 2px 4px rgba(0,0,0,0.1)"
                : "none",
              transition: "all 0.15s ease",
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default ServerStatusPills;
